import React from 'react';

import { LogoWithFallback } from '../logo-with-fallback';
import unknownIcon from './unknown-provider-icon.svg';
import unknownLogo from './unknown-provider-logo.svg';

/**
 * @typedef {object} ProviderDisplayInformation
 * @property {string} [logoUrl] - URL for the provider logo image
 * @property {string} [iconUrl] - URL for the provider icon image
 */

/**
 * @typedef {object} ProviderLogoProps
 * @property {ProviderDisplayInformation} [displayInformation] - Object containing URLs for provider logos
 * @property {'icon'|'alternateIcon'|'logo'} type - The type of logo to display
 */

const emptyDisplayInformation = {};

/**
 * Provider-specific logo component with default unknown provider fallbacks
 * @param {ProviderLogoProps & React.ImgHTMLAttributes<HTMLImageElement>} props
 * @returns {React.JSX.Element}
 */
export const ProviderLogo = ({ displayInformation = emptyDisplayInformation, type, ...rest }) => {
  return (
    <LogoWithFallback displayInformation={displayInformation} iconFallback={unknownIcon} logoFallback={unknownLogo} type={type} {...rest} />
  );
};
